import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { full } from "./shared/routes/full.routes";
import { content } from "./shared/routes/routes";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('../app/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: "running-orders-display",
    loadChildren: () => import("./views/running-orders-display/running-orders-display.module").then((m) => m.RunningOrdersDisplayModule),
  },
  {
    path: '',
    component: ContentComponent,
    children: content 
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [
    [
      RouterModule.forRoot(routes, {
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
        useHash : true,
      }),
    ],
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
